import { useMemo } from 'react'

import { useWindow } from '@krp/client-runtime'
import {
  aqsiSaleExchanges,
  makeSelectSaleExchangeVm,
  saleExchangesReloadRequested,
  SaleExchangeScreen,
  type SaleExchangeActions,
  type SaleExchangesArgs,
} from '@krp/resource-aqsi-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import type { RootState } from '../../app/types'

/** Окно «Обмен с AQSI» продажи: rid и продажа — из адреса окна; только чтение журнала обмена службы. */
export function AqsiSaleExchangeBinding() {
  const window = useWindow()
  const dispatch = useAppDispatch()
  const resourceId = window.params.rid ?? ''
  const saleId = window.params.saleId ?? ''
  const args = useMemo<SaleExchangesArgs>(() => ({ resourceId, saleId }), [resourceId, saleId])
  aqsiSaleExchanges.useQuerySubscription(args, { skip: resourceId === '' || saleId === '' })
  const selectVm = useMemo(() => {
    const selectPackageVm = makeSelectSaleExchangeVm()
    const selectExchanges = aqsiSaleExchanges.select(args)
    return (state: RootState) => selectPackageVm({ resourceId, saleId, exchanges: selectExchanges(state) })
  }, [args, resourceId, saleId])
  const vm = useAppSelector(selectVm)
  const actions = useMemo<SaleExchangeActions>(
    () => ({
      reload: () => dispatch(saleExchangesReloadRequested({ resourceId, saleId })),
      close: window.close,
    }),
    [dispatch, resourceId, saleId, window.close],
  )
  return <SaleExchangeScreen vm={vm} actions={actions} />
}
